import { render } from "./ProviderName.vue?vue&type=template&id=d79381a2"
import script from "./ProviderName.vue?vue&type=script&lang=js"
export * from "./ProviderName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__